import React from 'react';

import i18n from 'i18next';

import {
  getMenuItems,
  ListBody,
  ListEmpty,
  ListHeader,
} from '@/exceed';

import Initiative from './initiative';

const ListItem = ({ item }) => <Initiative initiative={item} />;

const Initiatives = ({
  filters,
  filterSelection,
  initiatives,
  isFiltered,
  isLoading,
  onClearButtonClick,
  onCreateButtonClick,
  onFilterChange,
}) => {
  const addMenuItems = getMenuItems([
    {
      icon: 'initiative',
      isLink: true,
      key: 'new-initiative',
      route: '/initiatives/new',
    },
  ]);

  return (
    <div>
      <ListHeader
        addMenuItems={addMenuItems}
        filters={filters}
        hasAddMenu
        hasFilters
        nameText={i18n.t('initiative-name')}
        onClearButtonClick={onClearButtonClick}
        onFilterChange={onFilterChange}
        filterSelection={filterSelection}
        shouldDisableFilters={!initiatives.length && !isFiltered}
        title={i18n.t('initiative')}
      />
      <ListBody
        countText={i18n.t('initiatives-count')}
        data={initiatives}
        emptyComponent={(
          <ListEmpty
            body={i18n.t('initiatives-empty-body')}
            buttonText={i18n.t('initiatives-empty-button')}
            hasButton
            onButtonClick={onCreateButtonClick}
            title={i18n.t('initiatives-empty-title')}
          />
        )}
        hasCount
        hasQuery={isFiltered}
        isInitiallyExpanded
        isLoading={isLoading}
        ListItem={ListItem}
      />
    </div>
  );
};

export default React.memo(Initiatives);
